import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

export class ResponseErrorMessage extends Error {
  constructor(
    override message: string,
    readonly request: HttpRequest<unknown>,
    readonly errorResponse: HttpErrorResponse,
  ) {
    super(message);
  }
}

export function throwResponseError(
  message: string,
  request: HttpRequest<any>,
  error: HttpErrorResponse,
): Observable<never> {
  throw new ResponseErrorMessage(message, request, error);
}
